var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRBnb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "staker---staking-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    transform: "translate(-123.000000, -247.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(124.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cosmos-logo-horizontal-dark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9999365,0 C58.9867462,0 76,17.0131586 76,37.9999365 C76,58.9867462 58.9867462,76 37.9999365,76 C17.0131586,76 0,58.9867462 0,37.9999365 C0,17.0131586 17.0131586,0 37.9999365,0 Z",
    id: "Path",
    strokeOpacity: 0.2,
    stroke: "#00F3AB",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2983587,38 L18.646737,43.646737 L13,38 L18.646737,32.353263 L24.2983587,38 Z M38,24.2885893 L47.6766315,33.9701055 L53.3233685,28.3233685 L38,13 L22.6766315,28.3233685 L28.3233685,33.9701055 L38,24.2885893 Z M57.3581477,32.353263 L51.7114107,38 L57.3581477,43.646737 L63,38 L57.3581477,32.353263 Z M38,51.7114107 L28.3233685,42.0347792 L22.6766315,47.6766315 L38,63 L53.3233685,47.6766315 L47.6766315,42.0347792 L38,51.7114107 Z M38,43.646737 L43.646737,38 L38,32.353263 L32.353263,38 L38,43.646737 Z",
    id: "path16",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,10 C18.0898509,10 21,12.9101491 21,16.5 C21,20.0898509 18.0898509,23 14.5,23 C10.9101491,23 8,20.0898509 8,16.5 C8,12.9101491 10.9101491,10 14.5,10 Z M14.7653759,13 L13,13 L13,21 L14.7653759,21 L14.7653759,17.6926677 C14.7653759,16.4945398 16.428246,15.1466459 17.8063781,15.1466459 L18,15.1466459 L18,13.2121685 L17.8063781,13.2121685 C16.5990888,13.2121685 15.3120729,13.7113885 14.7653759,14.6848674 L14.7653759,13 Z",
    id: "Combined-Shape-Copy-9",
    fill: "#00F3AB"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRBnb);
export default __webpack_public_path__ + "static/media/rBNB.87defa90d36bc20d8c3e51cc8db80ce3.svg";
export { ForwardRef as ReactComponent };